import { Component, OnInit, AfterViewInit, Injector } from '@angular/core';
import { LeaderBoardComponent, LeaderboardExt } from '../leaderBoard/leaderBoard.component';
import { ILeaderBoardRs } from '../../interfaces/service.response';
import { Leaderboard } from '../../api/DixApiClient';

@Component({
  selector: 'app-mobile-leaderboard',
  template: require('./mobile-leaderboard.component.html'),
  styles: [require('./mobile-leaderboard.component.scss')]
})
export class MobileLeaderboardComponent extends LeaderBoardComponent implements OnInit, AfterViewInit{

  constructor(injector: Injector) { 
    super(injector)

    this.refresh();


    this.workspace.quoteTabsActiveModeService.subscriber.subscribe(v=>{
      console.log("this.workspace.quoteTabsActiveModeService.subscriber")
      console.log(v)
      if(v=="leaderboard" && this.type=="active")
      {
        clearTimeout(this.currentTimeout);
        this.refresh();
      }
    })


    this.dataService.dataSubscriber.subscribe(response => {
      if (response.Type == "LeaderBoardRs") {
        clearTimeout(this.currentTimeout);
          var leaderBoardResponse: ILeaderBoardRs = <ILeaderBoardRs>response;
          if(this.tournamentId==leaderBoardResponse.TournamentId)
          {
          this.leadeboardList = leaderBoardResponse.ContestantResults.map(v => {
              let t = new LeaderboardExt();
              t.accountId = v.AccountId;
              t.accountName = v.AccountName;
              t.pnL = v.PnL;
              t.place = v.Place;
              t.isCurrentUser = v.IsCurrentUser;
              t.Pips = v.Pips
              return t;
          });

          if(this.type=="active")
          {

            this.currentTimeout = setTimeout(() => {
              this.refresh()
            }, 60*1000);
            }

          }
        }


     

  });
  
  }

  ngOnInit() {
  }

}
